<template>
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">

      <!-- Dashboard -->
      <li class="nav-item">
        <sidenav-collapse to="/dashboard" activeRoute="dashboard" navText="Dashboard">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Contacts -->
      <li class="nav-item">
        <sidenav-collapse to="/contacts" activeRoute="contacts" navText="Contacts">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">contacts</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Our Partners-->
      <li class="nav-item">
        <sidenav-collapse to="/partners" activeRoute="partners" navText="Our Partners">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">business</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Insurance Types-->
      <li class="nav-item">
        <sidenav-collapse to="/insurances" activeRoute="insurances" navText="Insurance Types">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">insights</i>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  components: {
    SidenavCollapse,
  },
};
</script>
